<div class="filter-container">
  <button mat-flat-button (click)="onPrev()">Prev</button>
  <!-- Select dropdown for choosing column to filter -->
  <mat-form-field appearance="outline">
    <mat-label>Select Column</mat-label>
    <mat-select [(value)]="selectedColumn" (selectionChange)="onFilterChange()">
      @for (colum of displayedColumns; track colum) {
      <mat-option [value]="colum">{{ colum }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Text input field for filtering -->
  <mat-form-field appearance="outline">
    <mat-label>Filter</mat-label>
    <input
      matInput
      [(ngModel)]="filterValue"
      (ngModelChange)="onFilterChange()"
      placeholder="Filter by {{ selectedColumn }}"
    />
  </mat-form-field>

  <button mat-flat-button (click)="onNext()">Next</button>
</div>

<div class="offline-container">
  <mat-label>Device offline: {{ offlineTotal }}</mat-label>
</div>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <ng-container matColumnDef="mac">
    <th mat-header-cell *matHeaderCellDef>Mac Address</th>
    <td mat-cell *matCellDef="let element">{{ element.mac }}</td>
  </ng-container>
  <ng-container matColumnDef="serialNumber">
    <th mat-header-cell *matHeaderCellDef>Seriale</th>
    <td mat-cell *matCellDef="let element">{{ element.serialNumber }}</td>
  </ng-container>
  <ng-container matColumnDef="model">
    <th mat-header-cell *matHeaderCellDef>Modello</th>
    <td mat-cell *matCellDef="let element">{{ element.model }}</td>
  </ng-container>
  <ng-container matColumnDef="firmware">
    <th mat-header-cell *matHeaderCellDef>Firmware</th>
    <td mat-cell *matCellDef="let element">{{ element.firmware }}</td>
  </ng-container>
  <ng-container matColumnDef="group">
    <th mat-header-cell *matHeaderCellDef>Gruppo</th>
    <td mat-cell *matCellDef="let element">
      <mat-form-field class="device-group" appearance="outline">
        <mat-label>Gruppo</mat-label>
        <mat-select
          (selectionChange)="onGroupChange(element.mac, $event.value)"
          [(ngModel)]="element.group"
        >
          @for (group of groups; track $index) {
          <mat-option [value]="group">{{ group }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </td>
  </ng-container>
  <ng-container matColumnDef="dateRegister">
    <th mat-header-cell *matHeaderCellDef>Data Registrazione</th>
    <td mat-cell *matCellDef="let element">{{ element.dateRegister }}</td>
  </ng-container>
  <ng-container matColumnDef="dateLastRequest">
    <th mat-header-cell *matHeaderCellDef>Ultimo dateLastRequest</th>
    <td mat-cell *matCellDef="let element">{{ element.dateLastRequest }}</td>
  </ng-container>
  <ng-container matColumnDef="offline">
    <th mat-header-cell *matHeaderCellDef>Offline: {{ offline }}</th>
    <td mat-cell *matCellDef="let element">
      <mat-icon [style.color]="element.offline ? 'red' : 'green'">
        circle
      </mat-icon>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
